import { cloneElement, forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

export const Textarea = forwardRef(
  (
    {
      label,
      icon: initialIcon,
      containerClassName,
      inputClassName,
      labelClassName,
      className,
      disabled,
      shadow = true,
      error,
      errorClassName,
      ...props
    },
    ref
  ) => {
    const icon = initialIcon
      ? cloneElement(initialIcon, {
          className: twMerge('shrink-0', initialIcon.props?.className)
        })
      : null;
    return (
      <fieldset className={twMerge('fieldset w-full', containerClassName)}>
        {!!label && (
          <legend className={twMerge('fieldset-legend pb-1', labelClassName)}>
            {label}
          </legend>
        )}
        <div
          className={twMerge(
            'input input-beautifi relative flex items-center pe-0 h-auto overflow-hidden',
            !icon && 'ps-0',
            !disabled && 'shadow-beautifi',
            disabled && 'input-disabled opacity-40',
            error ? 'input-error text-error' : '',
            inputClassName
          )}
        >
          {!!icon && icon}
          <textarea
            {...props}
            ref={ref}
            className={twMerge('grow h-full px-3 py-3', className)}
            disabled={disabled}
          />
        </div>
        {!!error?.message && (
          <p className={twMerge('fieldset-label text-error', errorClassName)}>
            {error?.message}
          </p>
        )}
      </fieldset>
    );
  }
);

Textarea.displayName = 'Textarea';
